import fetch from '@/utils/fetch'
import request from './request'
import config from '@/config'
const baseUrl = config.service.apiUrl

export default {
    payByAlipay() {
        return request({
            url:  baseUrl + '/order/pay/alipay/h5/pay',
            method: 'post',
            data: {
                productCode:'PINGAN_TRAIN_30'
            }
        });
    },
	payByAlipayOld() {
	    return request({
	        url:  baseUrl + '/order/pay/alipay/h5/payOld',
	        method: 'post',
	        data: {
	            productCode:'PINGAN_TRAIN_30'
	        }
	    });
	},
    payByWechat(productCode) {
        return request({
            url: baseUrl + '/order/pay/wechat/h5/pay',
            method: 'post',
            data: {
                productCode
            }
        });
    },
	payByWechatJS(productCode) {
	    return request({
	        url: baseUrl + '/order/pay/byWechatpay',
	        method: 'post',
	        data: {
	            productCode,
				userId:localStorage.getItem("userId"),
				wechatMP: 'MOFANGGUANJIA',
				channel:localStorage.getItem("pa.channel")
				
	        }
	    });
	},
    userLogin (code) {
        return request({
            url: baseUrl + '/user/user/login?mpCode=PINGAN&code=' + code,
            method: 'get'
        });
    }
}
